/**
 * Where an admin surface reads a speaker's not-yet-published portrait.
 *
 * Shared so the route that serves it and the table that points at it cannot
 * drift apart. The server module owns the authorization; this file owns only the
 * address, and deliberately carries no logic that a browser bundle should not
 * see.
 */
export const ADMIN_SPEAKER_PORTRAIT_PATH = "/admin-storage/speaker-portrait";

/** The URL an admin surface points an `img` at for a given speaker. */
export function adminSpeakerPortraitHref(speakerId: number) {
  return `${ADMIN_SPEAKER_PORTRAIT_PATH}/${speakerId}`;
}
